module.exports = __webpack_public_path__ + "img/Vectoradd.ba540814.svg";